module.exports = __webpack_public_path__ + "73f18e0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/icon-courier@2x.png
// module id = 1046
// module chunks = 0